module.exports = {

  requestUser: function (userId, username) {
    return this.client.post(`${this.migrationRoot}/china/request`, {
      'destination_user_id': `${userId}`,
      'destination_username': `${username}`,
    })
  },

  confirmUser: function (confirmationCode) {
    return this.client.post(`${this.migrationRoot}/china/confirm`, {
      'confirmation_code': `${confirmationCode}`,
    })
  },

}
